import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from '../patient-message/PatientMessage.module.css';
import CareTeamMessageList from './CareTeamMessageList';
import { setStaffChatList, setStaffChatVisible, setStaffNewChat, setStaffSelectedIndex, setStaffRecipient } from './CareTeamMessageSlicer';
import FilterChatView from '../../components/FilterChatView';
import managementStyles from '../ManagementPages.module.css';
import useAxios from '../../services/AxiosConfig';
import { resetFilterState } from '../../slicers/FilterChatSlice';

const CareTeamMainContainer = () => {
    const dispatch = useDispatch();
    const axiosConfig = useSelector((state) => state.axiosConfig);
    const axios = useAxios(axiosConfig.envURL);
    const userId = useSelector((state) => state.userInfo.id);
    const [careTeamList, setCareTeamList] = useState([]);

    const onNewMessageHandler = () => {
        dispatch(setStaffSelectedIndex(-1));
        dispatch(setStaffChatList([]));
        dispatch(setStaffChatVisible(true));
        dispatch(setStaffNewChat(true));
    }

    const handleChatContainerClose = () => {
        dispatch(setStaffChatVisible(false));
        dispatch(setStaffSelectedIndex(-1));
        dispatch(setStaffChatList([]));
        dispatch(setStaffNewChat(false));
        dispatch(setStaffRecipient({ 'id': 0, name: "" }));
    };

    const fetchCareTeamList = async () => {

        const staff = await axios.get(`/list/staffAdmin/${userId}`);
        if (Array.isArray(staff.data.data)) {
            const formattedStaff = staff.data.data.map(staff => {
                // For each id array, only include non-null values
                // If all are null, return an empty array as required
                const organizationIds = staff.groups
                    .map(group => group.organizationId)
                    .filter(id => id !== null && id !== undefined);

                const rawGroupIds = staff.groups
                    .map(group => group.groupId)
                    .filter(id => id !== null && id !== undefined);
                const groupIds = rawGroupIds.length > 0 ? rawGroupIds : [];

                const rawSubGroupIds = staff.groups
                    .map(group => group.subGroupId)
                    .filter(id => id !== null && id !== undefined);
                const subGroupIds = rawSubGroupIds.length > 0 ? rawSubGroupIds : [];

                const rawTeamIds = staff.groups
                    .map(group => group.teamId)
                    .filter(id => id !== null && id !== undefined);
                const teamIds = rawTeamIds.length > 0 ? rawTeamIds : [];

                return {
                    id: staff.id,
                    name: staff.firstName + " " + staff.lastName,
                    organizationIds,
                    groupIds,
                    subGroupIds,
                    teamIds,
                };
            });
            setCareTeamList(formattedStaff);
        } else {
            setCareTeamList([]);
        }
    }

    useEffect(() => {
        fetchCareTeamList();
        dispatch(resetFilterState());
    }, []);

    return (
        <div className={managementStyles.MiddleContent}>
        <div className={styles.FilterContainer}>
            <FilterChatView
                view='StaffMessage'
                isOrganization={true}
                isGroup={true}
                isSubGroup={true}
                isTeam={true}
                showDeleteButton={false}
                addButtonLabel={'New Message'}
                onAddHandler={onNewMessageHandler}
            />
            <CareTeamMessageList
                onCloseClick={handleChatContainerClose}
                careTeamList={careTeamList} 
            />
        </div>
    </div>
    );
};

export default CareTeamMainContainer;
